export const AbrirRegresos = () => {
  document.getElementById("regresos").style.display = "block";
  document.getElementById("contenedorRegresos").style.display = "block";

  const enRuta = document.querySelector("#enRuta");

  if (enRuta) {
    enRuta.classList.remove("col-12");
    enRuta.classList.add("col-9");
    document.getElementById("contenedorEnRuta").style.display = "none";
  }
};
export const CerrarRegresos = () => {
  if (!document.getElementById("contenedorRegresos")) return;
  document.getElementById("contenedorRegresos").style.display = "none";
  const cerrar = document.querySelector(".icono-cerrar");
  const columna1 = document.querySelector("#enRuta");

  if (cerrar) {
    columna1.classList.remove("col-9");
    columna1.classList.add("col-12");
  }
};
